import {
    IAnimateTarget,
    IAnimationData,
    IAnimationPropertyData,
    PropertyPathFunc,
    PropertySetterFunc
} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/animation/AnimationTypes';
import {IRepeatedData} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/VisualBox';
import {DirectionType} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/layouts/hvbox/DirectionType';
import {LayoutModelFieldPaths} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/layouts/LayoutModelFieldPaths';
import {FractionalUnits} from '@mintdata/mint-kit/api/models/FractionalUnits';
import {FractionalUnitsType} from '@mintdata/mint-kit/api/models/FractionalUnitsType';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {Styler} from 'stylefire';

export const layoutData = (cssProperty?:string,
                           propertyPath:string | PropertyPathFunc = 'unitsString',
                           setter?:PropertySetterFunc
):IAnimationPropertyData => ({
    cssProperty,
    defaultFromValue: 0,
    propertyPath,
    setter
});

export const basicLayoutData = layoutData();

export const widthLayoutData = layoutData(
    null,
    (animationTarget:IAnimateTarget):string =>
    {
        const {
            visualBox: {
                box: {
                    componentDesc: {
                        isSelfDirected
                    }
                },
                parent,
                parentRepeater
            }
        } = animationTarget;
        const parentData:IRepeatedData = parent.repeatedData.get(parentRepeater.index);
        const isRowDirection:boolean = DirectionType.isRow(parentData.childLayout.hvBox.direction)
            || DirectionType.isRowReversed(parentData.childLayout.hvBox.direction);

        return isSelfDirected
            ? 'unitsString'
            : isRowDirection
                ? LayoutModelFieldPaths.HV_BOX_MAIN_AXIS_SIZE_FIELD
                : LayoutModelFieldPaths.HV_BOX_CROSS_AXIS_SIZE_FIELD;
    },
    (animateTarget:IAnimateTarget,
     animationData:IAnimationData,
     styler:Styler,
     property:string,
     cssProperty:string,
     value:string) =>
    {
        const {
            visualBox: {
                box: {
                    componentDesc: {
                        isSelfDirected
                    }
                },
                parent,
                parentRepeater
            }
        } = animateTarget;

        if( isSelfDirected )
        {
            const units:FractionalUnits = FractionalUnits.auto();
            units.unitsString = AString.fromString(String(value));

            const parentData:IRepeatedData = parent.repeatedData.get(parentRepeater.index);
            const isRowDirection:boolean = DirectionType.isRow(parentData.childLayout.hvBox.direction)
                || DirectionType.isRowReversed(parentData.childLayout.hvBox.direction);

            if( isRowDirection && FractionalUnitsType.isFractions(units.unitsType) )
                styler.set('flexGrow', units.value.value);
            else
                styler.set('width', units.toCssString());
        }
        else
            styler.set('width', value);
    }
);

export const heightLayoutData = layoutData(
    null,
    (animationTarget:IAnimateTarget):string =>
    {
        const {
            visualBox: {
                box: {
                    componentDesc: {
                        isSelfDirected
                    }
                },
                parent,
                parentRepeater
            }
        } = animationTarget;
        const parentData:IRepeatedData = parent.repeatedData.get(parentRepeater.index);
        const isRowDirection:boolean = DirectionType.isRow(parentData.childLayout.hvBox.direction)
            || DirectionType.isRowReversed(parentData.childLayout.hvBox.direction);

        return isSelfDirected
            ? 'unitsString'
            : isRowDirection
                ? LayoutModelFieldPaths.HV_BOX_CROSS_AXIS_SIZE_FIELD
                : LayoutModelFieldPaths.HV_BOX_MAIN_AXIS_SIZE_FIELD;
    },
    (animateTarget:IAnimateTarget,
     animationData:IAnimationData,
     styler:Styler,
     property:string,
     cssProperty:string,
     value:string) =>
    {
        const {
            visualBox: {
                box: {
                    componentDesc: {
                        isSelfDirected
                    }
                },
                parent,
                parentRepeater
            }
        } = animateTarget;

        if( isSelfDirected )
        {
            const units:FractionalUnits = FractionalUnits.auto();
            units.unitsString = AString.fromString(String(value));

            const parentData:IRepeatedData = parent.repeatedData.get(parentRepeater.index);
            const isRowDirection:boolean = DirectionType.isRow(parentData.childLayout.hvBox.direction)
                || DirectionType.isRowReversed(parentData.childLayout.hvBox.direction);

            if( !isRowDirection && FractionalUnitsType.isFractions(units.unitsType) )
                styler.set('flexGrow', units.value.value);
            else
                styler.set('height', units.toCssString());
        }
        else
            styler.set('height', value);
    }
);
